// Композиция провайдеров приложения (app.md §4).
//
// Порядок важен: QueryProvider снаружи — офлайн-слой в T-007 будет инвалидировать
// кэш Query при успешном флаше очереди, значит клиент должен существовать раньше.
//
// Появятся здесь по мере готовности: I18nProvider и ToastProvider из
// @restomarker/ui-kit, AuthProvider поверх /me (T-001). Доменной логики
// в провайдерах нет — каталог, печать и мониторинг живут в modules/.

import type { PropsWithChildren, ReactElement } from 'react';

import { OfflineProvider } from './OfflineProvider';
import { QueryProvider } from './QueryProvider';

export function AppProviders({ children }: PropsWithChildren): ReactElement {
  return (
    <QueryProvider>
      <OfflineProvider>{children}</OfflineProvider>
    </QueryProvider>
  );
}
